export default "__VITE_ASSET__59de0f2f__"